import {
  LayoutDashboard, Car, ClipboardList, ArrowLeftRight, Wrench, CalendarClock,
  Euro, Fuel, ShieldAlert, Receipt, Tags, Wallet, FileText, CalendarDays, BarChart3, Users, Building2,
  Settings, Contact,
} from "lucide-react";

// Sidebar pages, in menu order. Each one is shown only when canOpenRoute allows it.
export const MENU = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard },
  { to: "/veicoli", label: "Veicoli", icon: Car },
  { to: "/assegnazioni", label: "Assegnazioni", icon: ClipboardList },
  { to: "/noleggi", label: "Preventivi e noleggi", icon: FileText },
  { to: "/consegne", label: "Consegne e riconsegne", icon: ArrowLeftRight },
  { to: "/manutenzioni", label: "Manutenzioni", icon: Wrench },
  { to: "/scadenze", label: "Scadenze", icon: CalendarClock },
  { to: "/costi", label: "Costi", icon: Euro },
  { to: "/rifornimenti", label: "Rifornimenti", icon: Fuel },
  { to: "/danni", label: "Danni e sinistri", icon: ShieldAlert },
  { to: "/multe", label: "Multe", icon: Receipt },
  { to: "/calendario", label: "Calendario", icon: CalendarDays },
  { to: "/tariffe", label: "Tariffe", icon: Tags },
  { to: "/economia", label: "Riepilogo economico", icon: Wallet },
  { to: "/report", label: "Report", icon: BarChart3 },
  { to: "/clienti", label: "Clienti", icon: Contact },
  { to: "/utenti", label: "Utenti", icon: Users },
  { to: "/fornitori", label: "Fornitori", icon: Building2 },
  { to: "/sedi", label: "Sedi", icon: Building2 },
  { to: "/impostazioni", label: "Impostazioni", icon: Settings },
];
